var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingsView',[_c('FeatureComingSoon',{attrs:{"featureId":_vm.featureId,"showTitle":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }